import { CrownMarker, CrownMarkerHighlighted } from "assets/pois-bounty/svg";
import classNames from "classnames";
import { usePoisBountyContext } from "components/PoisBountyWidgetV3/context";
import { Indicator } from "components/PoisBountyWidgetV3/lib/common";
import { useAppSelector } from "hooks";
import { selectPoisBountyV3State } from "redux/slices";
import { useStepContext } from "../Step/context";
import { StepMarker as StepMarkerStyled } from "./styles";

export const Marker = () => {
	const { target, last } = useStepContext();
	const { isPageVariant } = usePoisBountyContext();
	const { lp } = useAppSelector(selectPoisBountyV3State);
	const className = "crown-svg";
	const onTarget = target === lp;

	return (
		<StepMarkerStyled
			className={classNames([
				"step-marker",
				isPageVariant ? "page-variant" : "mega-menu-variant"
			])}
		>
			{onTarget && !last && <Indicator mode="marker" userLoyaltyPoints={lp} />}
			{target <= lp ? (
				<CrownMarkerHighlighted className={className} />
			) : (
				<CrownMarker className={className} />
			)}
		</StepMarkerStyled>
	);
};
